import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
import { Box, List, ListItemText, Typography } from '@mui/material';
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

// Supports two formats:
//   Flat:    [{ title, path, icon, badge? }, ...]
//   Grouped: [{ subheader, items: [{ title, path, icon, badge? }] }, ...]
//
// `badge` is an optional React node rendered after the label (e.g. a live unread count chip).
export default function NavSection({ data = [], ...other }) {
  const isGrouped = data.length > 0 && data[0].subheader !== undefined;

  if (isGrouped) {
    return (
      <Box {...other}>
        {data.map((section) => (
          <Box key={section.subheader}>
            <Typography
              variant="overline"
              sx={{
                px: 2.5,
                pt: 2,
                pb: 0.5,
                display: 'block',
                fontSize: '0.65rem',
                fontWeight: 700,
                letterSpacing: '0.08em',
                color: 'text.disabled',
              }}
            >
              {section.subheader}
            </Typography>
            <List disablePadding sx={{ px: 1 }}>
              {(section.items || []).map((item) => (
                <NavItem key={item.title} item={item} />
              ))}
            </List>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info, badge, external } = item;

  const content = (
    <>
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
      <ListItemText disableTypography primary={title} sx={{ flexGrow: 1 }} />
      {badge || null}
      {info  || null}
    </>
  );

  if (external) {
    return <StyledNavItem component="a" href={path}>{content}</StyledNavItem>;
  }

  return <StyledNavItem component={RouterLink} to={path}>{content}</StyledNavItem>;
}
